module.exports = __webpack_public_path__ + "img/Reassign.5bdd971a.svg";